import { render, staticRenderFns } from "./project_mcp_servers_index.vue?vue&type=template&id=1804574a"
import script from "./project_mcp_servers_index.vue?vue&type=script&lang=js"
export * from "./project_mcp_servers_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports